import React, { Component } from "react";
import { connect } from "react-redux";
import { TextField, Button } from "@material-ui/core";
import { adminSearchUser } from "../../../actions";
import { withStyles } from "@material-ui/styles";
import Spinner from "../../atoms/Spinner";
import Typography from "@material-ui/core/Typography";

const styles = theme => ({
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "60%",
    maxWidth: "500px"
  },

  error: {
    color: "red"
  }
});

class UserSearchField extends Component {
  constructor(props) {
    super();

    this.state = {
      searchtext: props.searchtext
    };
    this.submitHandler = this.submitHandler.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  submitHandler(event) {
    event.preventDefault();
    this.props.adminSearchUser(this.state.searchtext);
  }

  handleChange(event) {
    this.setState({ searchtext: event.target.value });
  }

  render() {
    const { classes, fetching, fetching_error } = this.props;
    return (
      <form onSubmit={this.submitHandler}>
        <TextField
          name="searchtext"
          className={classes.textField}
          value={this.state.searchtext}
          onChange={this.handleChange}
          helperText="Enter email, user id, order reference, kyc id, wallet address"
        />
        {!fetching && <Button type="submit">Search</Button>}
        {fetching && <Spinner className={classes.spinner} />}
        {fetching_error &&
          fetching_error.status &&
          fetching_error.status === 201 && (
            <Typography className={classes.error}>Not found!</Typography>
          )}
        {fetching_error &&
          fetching_error.status &&
          fetching_error.status !== 201 && (
            <Typography className={classes.error}>
              Connecting to server failed! Please retry.
            </Typography>
          )}
      </form>
    );
  }
}

const mapStateToProps = state => ({
  searchtext: state.admin.searchtext,
  fetching: state.admin.fetching,
  fetching_error: state.admin.fetching_error,
  fetching_success: state.admin.fetching_success
});

const mapDispatchToProps = dispatch => {
  return {
    adminSearchUser: searchtext => dispatch(adminSearchUser(searchtext))
  };
};

const UserSearchFieldRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserSearchField);
export default withStyles(styles)(UserSearchFieldRedux);
